import React from 'react'
import BGContainer from '../../Components/BGContainer'
import { Container } from '@mui/material'
import Centered from '../../Components/Centered'
import { titleStyle } from '../Main/constants'
import { EditableTypography } from '../../Components/EditableTypography'
import Photogalery from '../Main/Photogalery'
import { RezervovatButton } from '../Main/MainPage'

export default function PhotoPage() {
    return (
        <div>
            <BGContainer id={"fotogalerie"} sx={{ py: '120px' }}>
                <Container maxWidth='lg' sx={{ mt: '120px' }}>
                    <Centered>
                        <EditableTypography fireKey={'foto'} sx={{ mt: '0px', ...titleStyle, textAlign: 'center', mb: '120px' }} />
                    </Centered>
                    <Photogalery />
                    <RezervovatButton buttons={false} />
                </Container>
            </BGContainer>
        </div>
    )
}
